// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MenuOutlinedSvg from "@fishx/icons-svg/es/asn/MenuOutlined";
import FishxIcon from '../components/FishxIcon';

var MenuOutlined = function MenuOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MenuOutlinedSvg
  }));
};

MenuOutlined.displayName = 'MenuOutlined';
export default React.forwardRef(MenuOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MenuOutlined.js
// module id = 3120
// module chunks = 0